import { Zap, RefreshCw } from 'lucide-react';
import { useUsageBalance } from '../../hooks/useUsageBalance';
import { LoadingSpinner } from '../common/LoadingSpinner';

export function ApiCredits() {
  const { totalCreditsRemaining, isLoading, error, refresh } = useUsageBalance();

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
        <Zap className="h-5 w-5 text-gray-500 dark:text-gray-400" />
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
            API Credits
          </label>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            Usage-based billing for Developer Platform API calls. See{' '}
            <a href="/account?tab=pricing" className="text-[#E34290] hover:underline">
              pricing
            </a>{' '}
            for details
          </p>
        </div>
      </div>

      {/* Current Usage */}
      <div className="p-4 border border-gray-200 dark:border-gray-600 rounded-lg">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-gray-900 dark:text-gray-100">Account Balance</h3>
          <a href="/api-keys" className="text-sm text-[#E34290] hover:underline">
            Manage API Keys →
          </a>
        </div>

        <div className="text-center">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-4">
              <LoadingSpinner size="sm" className="mb-2" />
              <div className="text-sm text-gray-600 dark:text-gray-400">Loading credits...</div>
            </div>
          ) : error ? (
            <div className="flex flex-col items-center justify-center py-4">
              <div className="relative inline-block mb-2">
                <div className="text-sm text-red-600 dark:text-red-400">Failed to load credits</div>
                <button
                  onClick={refresh}
                  disabled={isLoading}
                  className="absolute -top-1 -right-6 p-1 text-gray-400 hover:text-[#E34290] transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                  title="Refresh credits"
                >
                  <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
                </button>
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {error?.message || 'An error occurred'}
              </div>
            </div>
          ) : totalCreditsRemaining === 0 ? (
            <div className="flex flex-col items-center justify-center py-6">
              <div className="relative inline-block mb-2">
                <div className="text-2xl font-bold text-gray-400 dark:text-gray-500">0</div>
                <button
                  onClick={refresh}
                  disabled={isLoading}
                  className="absolute -top-1 -right-6 p-1 text-gray-400 hover:text-[#E34290] transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                  title="Refresh credits"
                >
                  <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
                </button>
              </div>
              <div className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                No credits remaining
              </div>
            </div>
          ) : (
            <>
              <div className="relative inline-block mb-2">
                <div className="text-4xl font-bold text-[#E34290]">
                  {totalCreditsRemaining.toLocaleString()}
                </div>
                <button
                  onClick={refresh}
                  disabled={isLoading}
                  className="absolute -top-1 -right-6 p-1 text-gray-400 hover:text-[#E34290] transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                  title="Refresh credits"
                >
                  <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
                </button>
              </div>
              <div className="text-sm text-gray-600 dark:text-gray-400">Credits Remaining</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
